/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Sparse CSS-variable override applied by the FE after palette derivation. name is a token name without prefix (e.g. action-gradient, bg-brand, primary-600); value is an opaque CSS value and may reference derived vars (e.g. var(--primary-600)). Applied via style.setProperty, so it wins in both light and dark mode.
 * @export
 * @interface TenantThemeVar
 */
export interface TenantThemeVar {
    /**
     * 
     * @type {string}
     * @memberof TenantThemeVar
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TenantThemeVar
     */
    value: string;
}

/**
 * Check if a given object implements the TenantThemeVar interface.
 */
export function instanceOfTenantThemeVar(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function TenantThemeVarFromJSON(json: any): TenantThemeVar {
    return TenantThemeVarFromJSONTyped(json, false);
}

export function TenantThemeVarFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantThemeVar {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function TenantThemeVarToJSON(value?: TenantThemeVar | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}

